"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.transactionFactory = Factory.Sync.makeFactory({
    transaction_id: Factory.each(i => i + 1),
    account_owner: mocks_1.persona.full_name,
    account_owner_id: mocks_1.persona.id,
    card_last_four: '1234',
    confirmation_id: 'CONF12345',
    credit_card_type_id: 1,
    currency_type: 'USD',
    department: 'Sales',
    fee_cents: 100,
    gross_cents: 1000,
    net_cents: 900,
    originator_group_description: 'Group Description',
    originator_group_id: 123,
    participants: 'participants',
    payment_method_brand: 'Visa',
    payment_method_type: 'Credit Card',
    payment_method_type_group_id: 2,
    payment_method_type_id: 3,
    payment_processor: 'Stripe',
    payment_processor_id: 456,
    payout_deposit_date: mocks_1.dates.date2000,
    payout_id: Factory.each(i => i + 1),
    sale_date: mocks_1.dates.date2000,
    sale_id: Factory.each(i => i + 1),
    sale_number: 'SN12345',
    sale_source: 'Online',
    source_system: 'System A',
    source_system_id: 1,
    tenant_id: 1,
    tenant_name: 'tenant_name',
    tenant_name_suffix: 'suffix',
    tenant_type: 'tenant_type',
    tenant_time_zone_code: 'PST',
    tenant_time_zone_offset: '-0800',
    tenant_transaction_date: mocks_1.dates.date2000,
    transaction_date: mocks_1.dates.date2000,
    transaction_type: 'Purchase',
});
